/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_OpenInputs */

const cs_property_ai_catalog_open = /** @type {(inputs: Property_Ai_Catalog_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít PDF`)
};

const en_property_ai_catalog_open = /** @type {(inputs: Property_Ai_Catalog_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open PDF`)
};

/**
* | output |
* | --- |
* | "Open PDF" |
*
* @param {Property_Ai_Catalog_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_open = /** @type {((inputs?: Property_Ai_Catalog_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_open(inputs)
	return cs_property_ai_catalog_open(inputs)
});